const TransactionGroupBouncedReportTableBody = ({ transactionsData }) => (
  <tbody>
    {transactionsData.map((transaction) => (
      <tr key={transaction.trans_uuid} title={transaction.trans_uuid}>
        <td>{transaction?.log_date ?? ''}</td>
        <td><p className="width300 text-truncate">{transaction?.trans_to_email ?? ''}</p></td>
        <td>
          <p className="width300 text-truncate">{transaction?.tm_subject ?? ''}</p>
        </td>
        <td><p className="width300 text-truncate">{transaction?.trans_bounce_type ?? ''}</p></td>
        <td><p className="width300 text-truncate">{transaction?.trans_bounce_reason ?? ''}</p></td>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <td><></></td>
      </tr>
    ))}
  </tbody>
);

export default TransactionGroupBouncedReportTableBody;
